import styled from 'styled-components';

const defaultWidth = '100%';
const defaultHeight = '50px';
const defaultFontSize = '14px';
const defaultColor = 'var(--color-brand-black)';
const defaultBgColor = 'var(--color-brand-white)';
const defaultBorderColor = 'var(--color-brand-grey-200)';
const defaultBorderRadius = 'var(--border-radius-md)';
const defaultFocusBorderColor = 'var(--color-brand-green-400)';
const defaultInvalidBorderColor = 'var(--color-brand-red-400)';

const TextInput = styled.input`
  border: solid 1px;
  border-color: ${props => props.borderColor || defaultBorderColor};
  border-radius: ${props => props.borderRadius || defaultBorderRadius};

  &[type="text"], &[type="search"], &[type="email"], &[type="password"]  {
    width: ${props => props.width || defaultWidth};
    height: ${props => props.height || defaultHeight};
    padding: 0 20px;
    font-size: ${props => props.fontSize || defaultFontSize};
    font-weight: 500;
    color: ${props => props.color || defaultColor};
    background-color: ${props => props.backgroundColor || defaultBgColor};
    background-clip: padding-box;
    appearance: none;
  }

  ::placeholder {
    opacity: 0.4;
  }

  :focus {
    outline: 0;
    border-color: ${props => props.focusBorderColor || defaultFocusBorderColor};
  }
  
  :disabled {
    opacity: 0.5;
  }
  
  :not([value=""]):not(:focus):invalid, :not(:focus)&.is-invalid {
    outline: 0;
    border-color: ${props => props.invalidBorderColor || defaultInvalidBorderColor};
  }

  :-webkit-autofill, :-internal-autofill-selected {
    -webkit-box-shadow: 0 0 0px 1000px white inset!important;
  }
`;

export default TextInput;

export const InvalidFeedBack = styled.div`
  font-size: 12px;
  margin-top: 8px;
  color: var(--color-brand-red-400);
  display: none;

  ${TextInput}:invalid ~ & {
    display: block;
  }
`;
